export default __webpack_public_path__ + "static/media/bg-purple-waves-horizontal.5a06c888.png";